import type { FC } from "react";

import { WidgetTitle } from "app/components/widget-title/WidgetTitle";
import { i18nFilter } from "app/filters/i18nFilter";

import { DeviceDistributionAddToDashboard } from "../DeviceDistributionAddToDashboard/DeviceDistributionAddToDashboard";

import { TitleContainer } from "./DeviceDistributionChartTitle.styles";
import type { IDeviceDistributionChartTitleProps } from "./DeviceDistributionChartTitle.types";

export const DeviceDistributionChartTitle: FC<IDeviceDistributionChartTitleProps> = ({ webSource }) => {
    const translate = i18nFilter();

    return (
        <TitleContainer>
            <WidgetTitle
                title={translate("wa.ao.trafficshare")}
                tooltip={translate("wa.ao.trafficshare.tooltip")}
            />
            <DeviceDistributionAddToDashboard
                metric="IndustryDeviceDistribution"
                type={"PieChart"}
                webSource={webSource}
            />
        </TitleContainer>
    );
};
